import { EditIcon, DeleteIcon } from '@chakra-ui/icons';

export const columnsDataModels = [
  {
    Header: "Id",
    accessor: "id",
  },
  {
    Header: "Descripción",
    accessor: "description",
  },
  {
    Header: "Marca",
    accessor: "brand.name",
  },
  {
    Header: '',
    accessor: 'actions',
    actions: [
      {
        label: 'Editar',
        icon: <EditIcon />,
        colorScheme: 'blue',
        type: 'edit'
      },
      {
        label: 'Eliminar',
        icon: <DeleteIcon />,
        colorScheme: 'red',
        type: 'delete'
      },
    ]
  }
];
